import React, { useState } from "react";
import Modal from "react-modal";
import { adminAddReviewItem } from "../../../../data/reducers/admin/reviews/review.reducer";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

//*********************************************************************************************************** */
const Model = ({ fetchReviewsApi }) => {
  const dispatch = useDispatch();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [loader, setloader] = useState(false);

  //   initial state of  form
  const [addReview, setAddReview] = useState({
    personName: "",
    personReview: "",
    clickAction: "",
  });

  Modal.setAppElement("#root");

  function OpenModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddReview({ ...addReview, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      setloader(true);
      const payload = {
        ...addReview,
      };
      // console.log('payload: ', payload);
      let response = await dispatch(adminAddReviewItem(payload));

      if (response.payload.isSuccessful) {
        fetchReviewsApi();
        closeModal();
        setloader(false);
        // setCampusList([...campusList, response.payload.data]);
        toast.success("Added successfully");
        return;
      } else if (!response.payload.isSuccessful) {
        setloader(false);
        toast.error(response.payload.message.data.message);
        return;
      }
      closeModal();
    } catch (error) {}
  };

  return (
    <div className="container">
      <button onClick={OpenModal} className="btn btn-primary align-self-end">
        Add review
      </button>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: {
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 10000,
          },
          content: {
            color: "#1D3883",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",

            backgroundColor: "#fff",
            // height: "80vh",
          },
        }}
      >
        <div className="container-fluid">
          <div className="row d-flex justify-content-center">
            <div className="col-12">
              <h5 className="text-center font-weight-bold">Add</h5>
            </div>
          </div>
          <div className="row d-flex justify-content-center p-3">
            <div className="col-12">
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label font-weight-bold text-dark"
                >
                  Name
                </label>
                <input
                  onChange={handleAddChange}
                  type="text"
                  className={`form-control form-control-lg `}
                  name="personName"
                  value={addReview?.personName}
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label font-weight-bold text-dark"
                >
                  Review
                </label>
                <textarea
                  onChange={handleAddChange}
                  type="text"
                  className={`form-control form-control-lg `}
                  name="personReview"
                  value={addReview?.personReview}
                />
              </div>
              <div className="mb-3">
                <label
                  htmlFor="exampleFormControlInput1"
                  className="form-label font-weight-bold text-dark"
                >
                  Click action <span class="text-muted">(optional)</span>
                </label>
                <input
                  onChange={handleAddChange}
                  type="text"
                  className={`form-control form-control-lg `}
                  name="clickAction"
                  value={addReview?.clickAction}
                />
              </div>

              <div className="col-12 p-0">
                <button
                  className="btn m-1 text-white btn-secondary"
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Yes
                  {loader && (
                    <span
                      class="spinner-border ml-1 spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                </button>
                <button
                  className="btn text-white m-1 btn-danger"
                  onClick={() => {
                    closeModal();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Model;
